<!-- 
Contents of the NOTICES tab of the levy collection setup page.
-->
<template>
  <div class="home">
    <our-heading 
      :breadcrumbs="getBreadcrumbs('setup')"
      :subtitle="statusDescription"
      title="Setup"
      subtitle-tooltip="Levy collection status"
      user-guide-topic="levy-collection-setup"
      user-guide-section="notice-templates"
    >
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs :levy-collection-id="levyCollectionId">
      <h3 class="title mb-0 ml-4 mt-4">
        Email addresses
        <our-user-guide-button topic="levy-collection-setup" section="email-addresses" in-title/>
      </h3>
      <email-configuration-panel :levy-collection-id="levyCollectionId" />
      <v-divider/>
      <h3 class="title mb-0 ml-4 mt-4">
        Notice templates
        <our-user-guide-button topic="levy-collection-setup" section="notice-templates" in-title/>
      </h3>
      <div class="px-5 pb-3">
        <notice-template-listing :levy-collection-id="levyCollectionId" embedded @click="openTemplate"/>
      </div>
      <v-divider/>
      <h3 class="title mb-0 ml-4 mt-4">
        Information sessions
        <our-user-guide-button topic="levy-collection-setup" section="information-sessions" in-title/>
      </h3>
      <information-sessions-panel :levy-collection-id="levyCollectionId" />
    </tabs>
  </div>
</template>

<script>
import levyCollectionSetupMixins from "./mixins";
import EmailConfigurationPanel from "@/components/levy-collection-setup/EmailConfigurationPanel.vue";
import NoticeTemplateListing from "@/components/notice-templates/NoticeTemplateListing.vue";
import InformationSessionsPanel from "@/components/levy-collection-setup/InformationSessionsPanel.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import Tabs from "./Tabs.vue";

export default {
  components: {
    Tabs,
    LevyCollectionNavigator,
    InformationSessionsPanel,
    NoticeTemplateListing,
    EmailConfigurationPanel
  },
  mixins: [levyCollectionSetupMixins],
  methods: {
    openTemplate(templateId) {
      this.$router.push({ path: `/levy-collections/${this.levyCollectionId}/setup/notices/${templateId}` });
    }
  }
};
</script>
